import {
  Heading,
  HStack,
  Pressable,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { Line } from './types';
import TrendingIconUpSVG from '../../CustomSVGs/TrendingIconUpSVG';
import styled from '@emotion/styled';
import { theme } from '../../../theme/theme';
import type { EmotionTheme } from '../../../theme/emotionTheme';

const Hoverable = styled('div')<{ readonly?: boolean; theme?: EmotionTheme }>`
  border-radius: 12px;
  border: 1px solid transparent;
  transition: all 200ms linear;

  &:hover {
    border-color: ${({ readonly }) =>
      readonly ? 'none' : theme.colors.cloud['200']};
    box-shadow: ${({ readonly, theme }) =>
      readonly ? 'none' : `0px 0px 24px 1px ${theme.colors.muted['200']}`};
  }
`;

type Props = {
  dataRangeLabel: string;
  line: Line;
  readonly?: boolean;
  onToggle: (dataKey: string, visible: boolean) => void;
};

export const TimeChartLegendItem = ({
  dataRangeLabel,
  line,
  onToggle,
  readonly,
}: Props) => {
  const { color, dataKey, displayLabel, visible } = line;

  return (
    <Pressable disabled={readonly} onClick={() => onToggle(dataKey, visible)}>
      <Hoverable readonly={readonly}>
        <VStack
          alignItems={'center'}
          justifyContent={'space-between'}
          h={'88px'}
          p={2}
          w={'112px'}
        >
          <VStack alignItems={'center'}>
            <HStack alignItems={'center'}>
              <TrendingIconUpSVG height={8} width={8} />

              <Heading color={'secondary.500'} fontSize={'2xl'} ml={2}>
                --
              </Heading>
            </HStack>

            <Text color={'blueGray.600'} fontSize={'2xs'}>
              {dataRangeLabel}
            </Text>
          </VStack>

          <HStack>
            <Box
              bgColor={visible ? color : undefined}
              borderColor={visible ? undefined : color}
              borderWidth={visible ? undefined : 1}
              h={'16px'}
              rounded={'full'}
              w={'16px'}
              mr={1}
            />

            <Text color={'secondary.600'} fontWeight={'normal'}>
              {displayLabel}
            </Text>
          </HStack>
        </VStack>
      </Hoverable>
    </Pressable>
  );
};
